export default __webpack_public_path__ + "static/media/essi3.30ea2655.jpg";